import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import { Link } from 'react-router-dom';
import './MyCompanies.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import icon_MoreOptions from './Icon More Options.png';
import icon_ConfigCompany from './Icon Config Company.png';
import icon_DefaultCompany from './Default Icon.png';
import { CSSTransition } from 'react-transition-group';
import api from './axios';


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


  
function MyCompanies() {
  const { user, updateUser } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [menu2Open, setMenu2Open] = useState(false);
  const menu2Ref = useRef(null);
  const { logout } = useAuth(); // Haal de logout-functie uit de context
  const navigate = useNavigate(); 
  const [newCompanyName, setNewCompanyName] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showQuestionYesNoPopup, setShowQuestionYesNoPopup] = useState(false);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [confirmLeave, setConfirmLeave] = useState(null);
  const [clickedCompanyId, setClickedCompanyId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('Support');
  const [Request_message, setRequestMessage] = useState("");
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);

  const { companyId, companyName, switchCompany } = useAuth();


  const handleSendHelpButton = async (event) => {
    event.preventDefault(); // voorkom page refresh
    setShowHelpPopup(false);
  
    try {
      // 1) Haal user- en companydata uit context
      const { id: user_id, name: user_name, email: user_email } = user;
  
      // 2) Verstuur support request via je axios-instance (api)
      await api.post('/api/requestforsupport', {
        user_id,
        user_email,
        user_name,
        company_id: companyId,
        company_name: companyName,
        Request_category: selectedCategory,
        Request_message,
        currentURL: window.location.href
      });
  
      // 3) Succesfeedback
      setMessage('Request for support sent successfully');
      setShowMessagePopup(true);
      setTimeout(() => setShowMessagePopup(false), 3000);
  
    } catch (err) {
      // 4) 401 → sessie verlopen, uitloggen
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId}`);
      } else {
        // 5) overige fouten
        const errMsg = err.response?.data?.error || err.message;
        setError('Error sending request for support: ' + errMsg);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    }
  };  

  const handleMyProfile = () => {
    navigate('/my-profile');
  };

  const handleSwitchCompany = () => {
    navigate('/my-companies');
  };

  const handleAddButton = async (event) => {
    event.preventDefault();
  
    // 1) Check of de naam al bestaat
    if (companies.some(c => c.name === newCompanyName)) {
      setError('Company name already exists');
      setShowCommentPopup(true);
      setTimeout(() => setShowCommentPopup(false), 3000);
      return;
    }
  
    setIsLoading(true);
  
    try {
      // 2) API-call via axios-instance, cookies gaan automatisch mee
      const { data } = await api.post('/api/create_workspace', {
        name: newCompanyName,
        user_id: user.id,
        user_email: user.email
      });
  
      // 3) Feedback aan gebruiker
      if (data.success) {
        setMessage('Company added successfully!');
        setShowMessagePopup(true);
        setTimeout(() => setShowMessagePopup(false), 3000);
        setShowPopup(false);
  
        // 4) Eerste company? Zet in context
        if (data.IsFirstCompany) {
          updateUser({ default_companyid: data.AddedCompanyId, company_roleId: 1 });
          switchCompany(data.AddedCompanyId, data.AddedCompanyName);
        }
  
        // 5) Herlaad lijst
        setReload(r => !r);
  
      } else {
        // API gaf succes:false
        setError('Company not added: ' + data.error);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        setShowPopup(false);
      }
  
    } catch (err) {
      // 6) 401 = sessie verlopen, anders generieke fout
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId}`);
      } else {
        setError('Error creating company: ' + (err.response?.data?.error || err.message));
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleCompanyClick = async (e, id, name, roleId) => {
    e.stopPropagation();
  
    try {
      // 1) Update default_company_id in de backend
      await api.post('/api/update_default_company', {
        user_id: user.id,
        company_id: id
      });
  
      // 2) Update user-context met de nieuwe default_companyid
      updateUser({ default_companyid: id, company_roleId: roleId });
  
      // 3) Switch in de UI-context naar deze company
      switchCompany(id, name);
  
      // 4) Reset eventueel eerder geopende rapporten
      localStorage.removeItem('lastOpenedReport_PBI_Id');
      localStorage.removeItem('lastOpenedReport_Id');
  
      // 5) Navigeer naar /main
      navigate('/main');
    } catch (err) {
      console.error('Error switching default company:', err);
      setError('Could not switch company: ' + (err.response?.data?.error || err.message));
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
      // 401 → sessie verlopen
      if (err.response?.status === 401) {
        await logout();
        navigate(`/login/${companyId || ''}`);
      }
    }
  }; 

  const handleIconConfigCompanyClick = (e, companyId, companyName) => {
    // Doe hier wat je wilt wanneer erop het icoon wordt geklikt
    navigate('/configcompany/'+companyId)
  }

  const handleAddCompany = () => {
    // Reset de staat van de bedrijfsnaam om het invulveld leeg te maken
    setShowPopup(true);
    setNewCompanyName("");
  };

  const handleLogout = async () => {
    // 1) Clear server‐side session and React context
    await logout();
  
    // 2) Redirect to login, preserving the current companyId in the URL
    navigate(`/login/${companyId || ''}`);
  };

  const handleClickOutside = (event) => {
    if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
      setMenu2Open(false);
    }
  };

  const handleMenu_Help = () => {
    setShowHelpPopup(true);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    // Opruimen bij ontkoppeling
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen


  const fetchData = async () => {
    try {
      const { data } = await api.get(`/api/usercompanies/${user.id}`);
      setCompanies(data);
    } catch (err) {
      console.error('Error fetching companies:', err);
      setError('Could not load companies: ' + (err.response?.data?.error || err.message));
      setShowErrorPopup(true);
    }
  };
  
  
  useEffect(() => {
    if (user?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);  // <-- lege dependency-array  

  // in My-companies.js, na je fetchData useEffect
  useEffect(() => {
    if (companies.length && companyId) {
      const defaultCompany = companies.find(c => c.id === companyId);
      if (defaultCompany) {
        switchCompany(companyId, defaultCompany.name);
      }
    }
  }, [companies, companyId, switchCompany]);


  useEffect(() => {
    const closeMenu = (e) => {
        if (!e.target.closest('.context-menu')) {
            setMenuOpen(null);
        }
    };

    document.addEventListener('click', closeMenu);

    return () => {
        document.removeEventListener('click', closeMenu);
    };
  }, []);

  useEffect(() => {
    if (confirmLeave === null) return;
  
    (async () => {
      if (confirmLeave) {
        try {
          // 1) Roep de leave_company endpoint aan met axios
          const { data } = await api.post('/api/leave_company', {
            user_id: user.id,
            company_id: confirmLeave
          });
  
          // 2) Feedback
          if (data.success) {
            setMessage('You have successfully left the company');
            setShowMessagePopup(true);
            setTimeout(() => setShowMessagePopup(false), 3000);
  
            // 3) Als we de actieve company have left, reset context
            if (confirmLeave === companyId) {
              switchCompany(null, null);
            }
  
            // 4) Default-company aanpassen als backend dat aangeeft
            if (data.new_defaultcompany_id != null) {
              updateUser({ default_companyid: data.new_defaultcompany_id });
              switchCompany(data.new_defaultcompany_id, data.new_defaultcompany_name);
            }
          } else {
            // API zei success: false
            setError('Error leaving company: ' + data.error);
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
          }
  
        } catch (err) {
          // 5) 401 → sessie verlopen
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId || ''}`);
          } else {
            // 6) Andere fouten
            setError('Error leaving company: ' + (err.response?.data?.error || err.message));
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
          }
        } finally {
          // 7) Herlaad de lijst na leave
          setReload(r => !r);
        }
      }
      // Reset confirmLeave
      setConfirmLeave(null);
    })();
  }, [confirmLeave]);


  // Als de gebruiker niet is ingelogd, render dan niets
  if (!user) 
  {
    //+navigate('/login/'+companyId); // Redirect naar de loginpagina // Redirect naar de loginpagina
    return null;
  }

  const positionMenu = (e, companyId) => {
    e.stopPropagation();
    setMenuPosition({ x: e.pageX, y: e.pageY });
    setMenuOpen(companyId);
    setClickedCompanyId(companyId);  // Geef companyId direct door
  };

  const handleMenuClick = async (action) => {
    // Stop het contextmenu
    setMenuOpen(null);
  
    // Bij 'leave' toon je gewoon de bevestiging
    if (action === 'leave') {
      setShowQuestionYesNoPopup(true);
      return;
    }
  
    // Bij 'setAsDefault' stuur je de API-call
    if (action === 'setAsDefault') {
      try {
        // 1) API-aanroep om default company te updaten
        const { data } = await api.post('/api/update_default_company', {
          user_id: user.id,
          company_id: clickedCompanyId
        });
  
        // 2) Check resultaat
        if (data.success) {
          setMessage('Default company updated successfully!');
          setShowMessagePopup(true);
          setTimeout(() => setShowMessagePopup(false), 3000);
  
          // 3) Update user state én context-active company
          updateUser({ default_companyid: clickedCompanyId });
          switchCompany(clickedCompanyId, companies.find(c => c.id === clickedCompanyId).name);
  
          // 4) Herlaad lijst
          setReload(r => !r);
  
        } else {
          // API gaf success: false
          setError('Default company not updated: ' + data.error);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
  
      } catch (err) {
        // 5) 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId || ''}`);
        } else {
          // andere errors
          setError('Error updating default company: ' + (err.response?.data?.error || err.message));
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      }
    }
  };


  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

    <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
        <div className="my-companies-title">My companies</div>

        <div style={{ position: 'relative' }}>
          <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
          <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
          {menu2Open && (
            <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
              <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
              <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
              <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                  {companyName ?? 'No company assigned'}
                  {
                    user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                      <a href={`/configcompany/${companyId}`}>
                        <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                      </a>
                    )
                  }
              </div>            
              <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
              <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
              <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
              <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
            </div>
          )}
        </div>
      </div>
    </header>

    <button className="add-company-button" onClick={handleAddCompany}>
        + Add company
    </button> {/* Nieuwe knop */}

    {showPopup && (
    <div className="popup-container">
        <div className="popup-content">
        <h2 style={{ fontWeight: 'normal' }}>Add company</h2>
        <div className="white-space"></div>
        <input
            type="text"
            placeholder="Company name *"
            className="company-name-input"
            value={newCompanyName}
            onChange={(e) => setNewCompanyName(e.target.value)}
        />
        <div className="buttons-container">
            <button onClick={() => setShowPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                Cancel
            </button>
            <button
                disabled={!newCompanyName}
                style={{ color: newCompanyName ? 'black' : 'grey', fontWeight: newCompanyName ? 'bold' : 'normal' }}
                onClick={handleAddButton}
            >
                Add
            </button>
        </div>
        {showCommentPopup && <div className="popup">{error}</div>}
        </div>
    </div>
    )}

    <div className="companies-list">
        {companies.length > 0 ? (
          <table className="company-table">
            <tbody>
              {companies.map((company) => (
                <tr className="company-name" key={company.id}>
                  <td onClick={(e) => handleCompanyClick(e, company.id, company.name, company.UserRoleId)} >{company.name}</td>
                  <td className="icon-cell">
                    {company.id == user.default_companyid ? 
                      <img 
                        src={icon_DefaultCompany} 
                        className="icon default-company"
                      />:
                      <div style={{width: '97px', height: '34px'}}></div>
                    }
                  </td>
                  <td className="icon-cell">
                    {["Admin", "Member"].includes(company.UserRoleDescription) ? 
                      <img 
                        src={icon_ConfigCompany} 
                        alt="Click to config company" 
                        className="icon" 
                        title="Configure company"
                        onClick={(e) => handleIconConfigCompanyClick(e, company.id, company.name)} 
                      /> :
                      <div style={{ width: 'iconWidth', height: 'iconHeight' }}></div>
                    }
                  </td>
                  <td className="icon-cell">
                    <div className="icon-container">
                      <img 
                        src={icon_MoreOptions} 
                        alt="More options" 
                        className="icon" 
                        title="More options"
                        onClick={(e) => positionMenu(e, company.id)} 
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-companies-text">
            No companies assigned yet. Please create a new company
          </div>
        )}
          <div 
            className="context-menu" 
            style={{
              top: `${menuPosition.y}px`,
              left: `${menuPosition.x}px`,
              display: menuOpen ? 'block' : 'none'
            }}
          >
          <ul>
            <li onClick={() => handleMenuClick('leave')}>Leave company</li>
            {/*
            {menuOpen !== user.default_companyid &&
              <li onClick={() => handleMenuClick('setAsDefault')}>Set as default</li>}
            */}
          </ul>
        </div>
      </div>

      {showMessagePopup && <div className="popup-message">{message}</div>}
      {showErrorPopup && <div className="popup">{error}</div>}
      {showPopupMessage && <div className="popup-message">{message}</div>}

      {isLoading && 
        <div className="loader-wrapper">
          <div className="loader"></div>
        </div>
      }
      {showQuestionYesNoPopup && (
      <div className="popup-container">
        <div className="popup-content">
        <h3 style={{ fontWeight: 'normal' }}>Are you sure you want to leave company?</h3>
        <div className="white-space"></div>
        <div className="buttons-container">
          <button onClick={() => {
            setConfirmLeave(true);
            setShowQuestionYesNoPopup(false);
            }} style={{ color: 'black', fontWeight: 'bold' }}>
              Yes
          </button>
          <button onClick={() => {
            setConfirmLeave(false);
            setShowQuestionYesNoPopup(false);
            }} style={{ color: 'black', fontWeight: 'bold' }}>
              No
          </button>
        </div>
        {showCommentPopup && <div className="popup">{error}</div>}
        </div>
      </div>
      )}

      {showHelpPopup && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
            <div className="white-space"></div>
            <b>From:</b>
            <input
                type="text"
                placeholder="Username"
                className="company-name-input"
                disabled="true"
                value={user.name || ""}
            />
            <b>Company:</b>
            <input
                type="text"
                placeholder="Company name"
                className="company-name-input"
                disabled="true"
                value={companyName || ""}
            />
            <div style={{ display: 'inline-block', marginRight: '10px' }}>
                <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                <select 
                  style={{ display: 'inline-block', width: '150px' }}
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
              >
                  <option value="Support">Support</option>
                  <option value="Customization request">Customization request</option>
              </select>
            </div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <b>Message:</b>
            <div className="white-space"></div>
            <textarea
                placeholder="Request for support message"
                className="company-name-input"
                rows="4"
                value={Request_message}
                style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                onChange={(e) => setRequestMessage(e.target.value)}
            ></textarea>
            <div style={{ height: '50px' }}></div>
            <div className="buttons-container">
                <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                  onClick={handleSendHelpButton}
                  style={{ color: 'black', fontWeight: 'bold' }}
                >
                Send request
                </button>
            </div>
            </div>
        </div>
      )}

      </div>
    </CSSTransition>
  )
}

export default MyCompanies;
